"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicationFlowImpl = void 0;
const luxon_1 = require("luxon");
/**
 * Extract and concat the injections on v2 format with flow from bilan.injections
 */
class MedicationFlowImpl {
    constructor(medic, flow, flowIndex) {
        this.getHoursMins = (flow) => {
            const date = flow.deleted_at ? flow.deleted_at : flow.started_at;
            return luxon_1.DateTime.fromISO(date)
                .setZone('Europe/Paris')
                .setLocale('fr-fr')
                .toLocaleString(luxon_1.DateTime.TIME_24_SIMPLE)
                .split(':');
        };
        this.getDate = (flow) => {
            const date = flow.deleted_at ? flow.deleted_at : flow.started_at;
            return date ? luxon_1.DateTime.fromISO(date).setZone('Europe/Paris').setLocale('fr-fr') : null;
        };
        this.injection_id = medic.id;
        this.type = 'injection';
        this.v2 = true;
        this.date = this.getDate(flow);
        this.heure = this.getHoursMins(flow)[0] ?? null;
        this.minute = this.getHoursMins(flow)[1] ?? null;
        this.ended_at = flow.ended_at
            ? luxon_1.DateTime.fromISO(flow.ended_at)
                .setZone('Europe/Paris')
                .setLocale('fr-fr')
                .toLocaleString(luxon_1.DateTime.TIME_24_SIMPLE)
            : null;
        let protocolIdentifier = medic.intervention_protocol ? `\\${medic.intervention_protocol.id}`
            : medic.nursing_protocol_name != null && medic.nursing_protocol_name != "" ? `\\${medic.nursing_protocol_name}` : "";
        this.name = `${medic.drug}\\${medic.drug_route_name}\\${medic.id}${protocolIdentifier}`;
        this.intervention_protocol = medic.intervention_protocol ?? null;
        this.flow_rate = medic.flow_rate ?? false;
        this.nursing_protocol_name = medic.nursing_protocol_name;
        this.ampoule_holder_identification = medic.ampoule_holder_identification;
        this.route_of_administration = medic.drug_route_name ?? null;
        this.unit = medic.weight_dependant ? medic.unit_numerator : medic.unit ?? null;
        this.flowQuantity = flow.quantity;
        this.flowState = this.getFlowState(medic, flow, flowIndex);
        let adjustLabel = flowIndex > 0 && this.getFlowState(medic, medic.flows[flowIndex - 1], flowIndex - 1) === 'break'
            ? 'Reprise' : 'Ajustement';
        switch (this.flowState) {
            case 'begin':
                this.flowStateDisplay = `Début`;
                break;
            case 'break':
                this.flowStateDisplay = `Pause`;
                break;
            case 'in_progress':
                this.flowStateDisplay = adjustLabel;
                break;
            case 'complete':
                this.flowStateDisplay = `${adjustLabel}${this.ended_at ? `\nFin à ${this.ended_at}` : ''}`;
                break;
            default: this.flowStateDisplay = '';
        }
        this.comment = [null, undefined, ''].includes(medic.comment) ? null : medic.comment;
    }
    getFlowState(medic, flow, flowIndex) {
        return flowIndex === 0 ? 'begin'
            : flowIndex === medic.flows.length - 1 && flow.ended_at ? 'complete'
                : flow.quantity && Number.parseFloat(flow.quantity) === 0 ? 'break'
                    : 'in_progress';
    }
}
exports.MedicationFlowImpl = MedicationFlowImpl;
